import React, {useState} from 'react';
import "video-react/dist/video-react.css";
import * as _ from "lodash";
import {Button} from "reactstrap";

import UserSection from "../../../../../components/messaging/chat-window-detail-header/user-section";
import assets from "../../../../../util/assets";

import {formattedPrice} from "../../../../../util/utility";
import "./index.css";
import {VideoPlayer} from "../../../../../components/clipstore/broadcaster/library/video-player";
import CommonImageCard from "../../../../../components/CommonImageCard";

UserLightbox.propTypes = {};

const carouselHorizontal = (arrayOfContent, setIndex) => {
    {
        return arrayOfContent.map((content, index) => {
            return (
                <CommonImageCard
                    pricing={false}
                    showBroadcasterSection={false}
                    containerClassName={"home-container-list-item-container-for-preview"}
                    imgLoadingContainer={"home-container-list-item-img-for-preview"}
                    imgContainerClassName={"home-container-list-item-img-container-for-preview"}
                    openDetail={(content) => {
                        const index = _.findIndex(arrayOfContent, function (o) {
                            return o.id === content.id
                        });
                        setIndex(index);
                    }}
                    content={content}
                />

            )
        })
    }
}

const getType = (content) => {
    if (content.hasOwnProperty("type")) {
        if (content.type === "video") {
            return "video";
        } else if (content.type === "picture") {
            return "photo";
        } else {
            return "gallery";
        }
    } else if (content.hasOwnProperty("videos") || content.hasOwnProperty("pictures")) {
        return "gallery";
    }
}

const bottomArray = (type, content) => {
    if (type === "gallery") {
        if (content.hasOwnProperty("videos") || content.videos.length > 0) {
            return content.videos;
        } else if (content.hasOwnProperty("pictures") || content.pictures.length > 0) {
            return content.pictures;
        } else {
            return [];
        }
    }
}
const getCenterContent = (props, type, content, price, btnTitle, purchaseChatContent, isFetching, setIndex) => {

    const wallet_balance = props.moneyblox.wallet_balance;
    const lowBalance = content.pricing.price > (Number(wallet_balance) * 100);
    const buttonTitle = `${btnTitle} ${price}`;

    return (
        <div className="user-lightbox-image-with-playbtn">
            <div className="user-lightbox-image-over-image">
                <img src={content.thumbnail_url} alt={content.title}/>
                {
                    type !== "photo" &&
                    <img src={assets.clipstore.home.video_play_hover} alt={"play button"} className="play-btn"/>
                }
            </div>
            <div className="user-lightbox-body-title">{content.title}</div>
            {
                type !== "photo" && content.pricing_type !== "free" &&
                <Button
                    disabled={lowBalance}
                    outline
                    color="primary"
                    className=""
                    onClick={() => {
                        console.log("onClick payment")
                        if (!isFetching) {
                            purchaseChatContent();
                        }
                    }}>
                    {
                        isFetching
                            ? <img src={assets.loading_blue} alt={"loading"} width={14}/>
                            :
                            buttonTitle
                    }

                </Button>
            }
            <div className="display-flex-align-center" style={{marginTop: 20}}>
                <img src={assets.messaging.wallet} alt={"wallet"}/>
                <span className="user-lightbox-wallet-balance secondary-color">£ {wallet_balance}</span>
                {lowBalance && <span className="user-lightbox-wallet-balance red-color">Your wallet is empty</span>}
                <span className="user-lightbox-wallet-balance primary-color underline cursor-pointer" onClick={() => {
                    props.showMoneyBloxModal();
                    props.hideUserLightBox();
                }}>Add Credit</span>
            </div>
        </div>
    )
}
const player = (props, content, purchaseChatContent, isFetching, setIndex) => {
    const type = getType(content);
    let price = formattedPrice(content.pricing.price);

    if (type === "video") {
        console.log("player", JSON.stringify(content))
        if (content.hasOwnProperty("url") && content.url.length > 0) {
            const videoJsOptions = {
                fluid: true,
                autoplay: true,
                controls: true,
                poster: content.thumbnail_url,
                sources: [{
                    src: content.url,
                }],
                aspectRatio: "16:9"
            }
            return (
                <div className="user-lightbox-image-with-playbtn">
                    <div className="user-lightbox-image-over-image">
                        <VideoPlayer {...videoJsOptions} />
                    </div>
                </div>
            )
        } else {
            return getCenterContent(props, type, content, price, "Entire Video", purchaseChatContent, isFetching, setIndex)
        }
    } else if (type === "photo") {
        return getCenterContent(props, type, content, price, "", purchaseChatContent, isFetching, setIndex)
    } else if (type === "gallery") {
        if (content.pricing_type === "free") {
            props.setLightBoxData(bottomArray(type, content));
            return (<span/>)
        }
        return getCenterContent(props, type, content, price, "Entire Gallery", purchaseChatContent, isFetching, setIndex)
    }
}

const purchaseChatContent = (props, chatContent) => {
    props.purchaseChatContent(chatContent.id, chatContent.amount);
}

function UserLightbox(props) {

    const [index, setIndex] = useState(0);
    const content = props.lightBoxData[index];
    const chatContent = props.currentMessage.data[index];


    return (
        <div className="user-lightbox-container">
            <div className="user-lightbox-container-chat">
                <div className="display-flex-align-center user-lightbox-header">
                    <UserSection
                        user={props.user}
                        broadcaster={props.broadcaster}
                        user_type={props.user_type}
                        selectedChannel={props.selectedChannel}
                    />
                    <img src={assets.messaging.preview.grey_cross}
                         className="padding-16 cursor-pointer"
                         alt={"cross"}
                         onClick={props.hideUserLightBox}
                    />
                </div>
                <div className="user-lightbox-preview">
                    <div className="user-lightbox-preview-body">
                        {
                            player(props, content, () => {
                                purchaseChatContent(props, chatContent)
                            }, props.buy_chat_post_content.isFetching, setIndex)
                        }
                    </div>

                    <div className="user-lightbox-preview-footer">
                        {
                            carouselHorizontal(props.lightBoxData, setIndex)
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}


export default UserLightbox;
